import type { SxProps, Theme } from "@mui/material";
import {
  AccountTreeOutlined,
  AutoStoriesOutlined as PartnerDirectoryIcon,
  BoltOutlined,
  DriveFolderUploadOutlined as SecureUploadIcon,
  HandshakeOutlined,
  HomeOutlined,
  HubOutlined as IntegrationsNavIcon,
  PeopleOutlined,
  PsychologyAlt,
  ShieldOutlined,
  StorageOutlined as StorageIcon,
  SyncOutlined,
} from "@mui/icons-material";
import type { NavProductKey } from "utils/navModel";

type IconFactory = (sx?: SxProps<Theme>) => React.ReactElement;

/** One icon per product, for the sidebar and the home tiles alike. */
export const PRODUCT_ICONS: Record<NavProductKey, IconFactory> = {
  home: (sx) => <HomeOutlined sx={sx} />,
  dataStorage: (sx) => <StorageIcon sx={sx} />,
  integrations: (sx) => <IntegrationsNavIcon sx={sx} />,
  integrationsPlatform: (sx) => <AccountTreeOutlined sx={sx} />,
  botsManagement: (sx) => <BoltOutlined sx={sx} />,
  sftpManagement: (sx) => <SyncOutlined sx={sx} />,
  secureExchange: (sx) => <SecureUploadIcon sx={sx} />,
  ai: (sx) => <PsychologyAlt sx={sx} />,
  partnerDirectory: (sx) => <PartnerDirectoryIcon sx={sx} />,
  partnerManagement: (sx) => <HandshakeOutlined sx={sx} />,
  userManagement: (sx) => <PeopleOutlined sx={sx} />,
  accessGroups: (sx) => <ShieldOutlined sx={sx} />,
};
